/*
	Copyright (c) 2022 PierceGearhart
    StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (StellaNode).
*/

// Utilities
import Header from '../components/header/index'
import Hero from '../components/heros/index'
import Features from '../components/landingFeatures'
import Footer from '../components/footer'
import Location from '../components/location'
import Panel from '../components/panel'
import CTO from '../components/cto'
import Title from '../components/title'

const Index = () => {
    Title('StellaNode')
    return (
        <main>
            <div className="bg-primary-light mb-10">
                <Header />
                <Hero type='home' />
            </div>
            <Features />
            <Location />
            <Panel />
            <CTO />
            <Footer />
        </main>
    )
}

export default Index